import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games ",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <TbShirtSport />,
    title: "Login to Account Manager",
    description:
      "Connect your Sacramento Kings account using our secure Ticketmaster login.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Select Your Seats",
    description:
      "Select where you wish to sit based on the amount of credit you have available.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your{" "}
        <Link
          href={"https://am.ticketmaster.com/sackings/"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Account Manager
        </Link>{" "}
        within 24 hours of redemption. Reach out to Live Fan Support for any
        questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Sacramento Kings Flex work?",
    description:
      "The Sacramento Kings Flex allows fans to select any seat to any game. Simply log into your Sacramento Kings Account Manager and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "No, you do not have to select all your games at once. Feel free to return at any point throughout the season to continue to use your credit.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description:
      "Yes, you can choose from all currently available inventory. The same number of seats for every game will automatically be applied.",
  },
  {
    title: "Where are my tickets delivered?",
    description:
      "Tickets will be delivered directly within your Sacramento Kings Account Manager.",
  },
];

export const SackingsRegistrationTerms = () => (
  <>
    By creating an account you agree to receive email notifications regarding
    your purchase and to the{" "}
    <Link
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      target={"_blank"}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);

export const SackingsCheckoutTerms = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);
